
import Vue from 'vue'
import RPHSeoText from 'rph/templates/RPHSeoText/index.vue'
import RPHProductMain from 'rph/templates/RPHProductMain/index.vue'
import RPHProductSpecsContainer from 'rph/templates/RPHProductSpecsContainer/index.vue'
import RPHReviewBlock from 'rph/organisms/RPHReviewBlock/index.vue'
import { IProduct } from 'types/DTO/products'
import { IEntityReviewProps } from 'types/DTO/reviews'

export default Vue.extend({
  name: 'RPHProduct',
  components: {
    RPHProductMain,
    RPHProductSpecsContainer,
    RPHReviewBlock,
    RPHSeoText,
  },
  computed: {
    product(): IProduct {
      return this.$store.getters['rph-products/product']
    },
    entityReview(): IEntityReviewProps {
      return {
        id: Number(this.product.id),
        type: 'product',
        short_title: this.product?.short_title,
        title: this.product?.short_title + ' ' + this.product?.specification?.issue_form,
        heading: 'Отзывы о товаре',
        placeholder: 'Опишите товар',
      }
    },
    isBlurred(): boolean {
      return this.$store.getters['rph-categories/isBlurred']
    },
    isAuth(): boolean {
      return this.$auth.loggedIn
    },
    mindboxUserId(): string {
      return this.$store.getters['rph-users/mindboxUserId']
    },
  },
  head() {
    return {
      meta: [
        {
          hid: 'og:image',
          name: 'og:image',
          //@ts-ignore
          content: this.product?.images[0].links.og_image,
        },
      ],
    }
  },
  methods: {
    checkAge() {
      if (this.product.is_adult === true) {
        if (!localStorage.getItem('isAdult') || localStorage.getItem('isAdult') !== 'true') {
          this.$store.commit('rph-categories/changeBlur', true)
          this.$store.dispatch('rph-modals/changeAdultModal', true)
        }
      } else {
        this.$store.commit('rph-categories/changeBlur', false)
        this.$store.dispatch('rph-modals/changeAdultModal', false)
      }
    },
    getBonusPoints() {
      this.$store.dispatch('rph-products/getBonusPoints', {
        isAuth: this.isAuth,
        products: [this.product],
        id: this.mindboxUserId,
        deliveryOption: 'default',
      })
    },
  },
  mounted() {
    this.$services.mindbox.mindboxViewProduct(this.product)
    this.checkAge()
    this.$services.anyQuery.anyQueryViewProduct(this.product)
    this.getBonusPoints()
  },
  watch: {
    mindboxUserId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (this.isAuth && newVal !== oldVal && newVal !== 0) {
          this.getBonusPoints()
        }
      },
    },
    isAuth: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getBonusPoints()
        }
      },
    },
  },
})
